<template>
    <div class="modal-card">
        <header class="modal-card-head" v-if="currentMethod">
            <p class="modal-card-title">Ananlytical Method</p>
        </header>
        <header class="modal-card-head" v-if="currentValidationPlanTemplate">
            <p class="modal-card-title">Validation Plan</p>
        </header>
        <section class="modal-card-body">
            <view-method-feature class="fullWidth" :currentMethod="currentMethod" v-if="currentMethod"></view-method-feature>

            <view-validation-plan-template-feature class="fullWidth" :assesmentMethods="assesmentMethods" :currentValidationPlanTemplate="currentValidationPlanTemplate" :validationParameters="validationParameters"
            v-if="currentValidationPlanTemplate"></view-validation-plan-template-feature>
        </section>
        <footer class="modal-card-foot">
            <button class="button" type="button" @click="$parent.close()">Close</button>
        </footer>
    </div>
</template>

<script>
import ViewMethodFeature from '../method/ViewMethodFeature'
import ViewValidationPlanTemplateFeature from '../template/ViewValidationPlanTemplateFeature'
import axios from "axios";
import { mapGetters } from 'vuex'
export default {
    name: 'DisplayViewModal',
    props: ["currentMethod", "currentValidationPlanTemplate"],
    components: {
        ViewMethodFeature, ViewValidationPlanTemplateFeature
    },
    computed: {
        ...mapGetters ([
            'base_url', 'auth_header', 'validationParameters'
        ])
    },
    data() {
        return {
            assesmentMethods:[]
        }
    },
    mounted () { 
        if(this.currentValidationPlanTemplate) {
            this.currentValidationPlanTemplate.assessment_methods_objects = []

            this.currentValidationPlanTemplate.assessment_methods.forEach(method => {
            })
            this.assesmentMethods = this.currentValidationPlanTemplate.ams;
        }
    },
    methods: {
        getAssesmentMethod: function(method, currentValidationPlanTemplate){
            axios
                .get(
                    this.base_url+ "experiments/assessments/"  +
                    method,
                    {
                        headers: this.auth_header
                    }
                )
                .then(response => {
                    var meth = response.data
                    meth.criteria =[]
                    var mainThis = this
                    console.log("debugging criteria", currentValidationPlanTemplate.criteria, method, meth)
                    currentValidationPlanTemplate.criteria.forEach(function(item, index, array) {
                        if(item.assessment_method==method || item.assessment_method==meth.code_name){
                            meth.criteria.push(item)
                        }
                    })
                    this.currentValidationPlanTemplate.assessment_methods_objects.push(meth)
                    this.assesmentMethods.push(meth)
                })
                .catch(error => {
                    console.log("Something went wrong getting the current ass meth", error);
                });
        },
    }
}
</script>

<style scoped>
.top-10 {
    margin-top: 10px !important;
}
</style>
